function filterArray(array, dataFunction, dataFilterFunction) {

    let filteredArray = [];
    for (const data of array) {

        let dataToFilter = data;
        if (dataFunction) {
            dataToFilter = dataFunction(data);
        }

        if (dataFilterFunction(dataToFilter, data)) {
            filteredArray.push(data)
        }
    }

    return filteredArray;
}


function routeDataFunction(data) {

    const [route] = data.path.split('/').slice(1);

    return route;
}


function makeRouteControlDataFilterFunction(routeControl) {

    const allRoutesAllowed = routeControl.allowAllRoutes ?? false;
    const roleRoutes = routeControl.routes ?? {};

    return (dataToFilter) => {
        const routeEnabled = roleRoutes[dataToFilter];

        if (routeEnabled === false) return false;

        if (!!!routeEnabled && !allRoutesAllowed) return false;

        return true;
    }
}


export function filterRoutesByRouteControl(routes, routeControl, options = {}) {

    if (!routeControl) {
        console.log('[filterByRouteControl] routeControl param is undefined. role might not be registered in the ROUTE_CONTROL object. Returning empty array.');
        return [];
    }

    let dataFunction = routeDataFunction;
    if (options?.dataFunction === true &&
        !!options?.dataFunctionMaker
    ) {
        dataFunction = options.dataFunctionMaker(dataFilterFunction);
    }

    let dataFilterFunction = makeRouteControlDataFilterFunction(routeControl);
    if (options?.dataFilterFunction === true &&
        !!options?.dataFilterFunctionMaker
    ) {
        dataFilterFunction = options.dataFilterFunctionMaker(dataFilterFunction);
    }

    let filteredRoutes = filterArray(
        routes,
        dataFunction,
        dataFilterFunction
    );

    return filteredRoutes;
}


export function getRouteControlByRole(role) {
    if (!!!role) {
        return {}
    }

    // NOTES:
    // - Keys in the route control object is based
    // on the `role` field in the `users` table
    // - `allowAllRoutes` property is used to enable all routes.
    // - `routes` property is used to specify which routes are available
    // - `defaultRoute` property is used to specify which route should
    // the user should be redirected to if location is not handled
    const ROUTE_CONTROL = {
        SUPERADMIN: {
            allowAllRoutes: true,
            defaultRoute: '/books',
        },
        ADMIN: {
            allowAllRoutes: true,
            defaultRoute: '/books',
        },
        ADMIN_TFP: {
            defaultRoute: '/grants',
            routes: {
                grants: true,
            },
        },
        ADMIN_REDAKSI: {
            allowAllRoutes: true,
            defaultRoute: '/books',
            routes: {
                grants: false,
                admins: false,
            }
        }
    };

    const normalizedRole = role?.toUpperCase();
    const routeControl = ROUTE_CONTROL[normalizedRole];

    return routeControl;
}
